export default __webpack_public_path__ + "static/media/servico2.467b4079.jpg";